import {ClientHttpException} from './ClientHttpException';

export class ServerHttpException extends ClientHttpException {
    public override get name(): string {
        return 'ServerHttpException';
    }
}
